module.exports = "<a #downloadAnchor download style=\"display:none;\" target=\"_self\"></a>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/rog-report-images/rog-report-images.component.html
// module id = ../../../../../src/app/rog-report-images/rog-report-images.component.html
// module chunks = main